jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

    var _wr = function(type) {
      var orig = history[type];
      return function() {
         var rv = orig.apply(this, arguments);
         var e = new Event(type);
         e.arguments = arguments;
         window.dispatchEvent(e);
         return rv;
      };
   };
   history.pushState = _wr('pushState');
   history.replaceState = _wr('replaceState');

   window.addEventListener('replaceState', function(e) {

   });
   window.addEventListener('pushState', function(e) {
     if (e.arguments.url.indexOf('loox') === -1) {
       location.reload();
     }
   });

   // pjax or reload page
    function pjax_LoadHref(url) {
      console.log($.pjax);
       // if ( $('.container_cat').length == 0 || typeof ($.fn.pjax) == 'undefined' ) {
       //     window.location.href = url;
       // } else {
         //location.href = currentUrlPrice;
         $.pjax({
          container: '.container_cat:not(.cat_des_ntt4)',
             fragment: '.container_cat:not(.cat_des_ntt4)',
             timeout: 50000,
              url: url,
          scrollTo: false
         });
       // }

    };
  
    var body = $('body');
   // filter product title .nt_cat_title
    body.on('click', '.filter_title_btn', function (e) {

      var _this = $(this),
         _title = _this.siblings('.nt_cat_title'),
         currentUrl = _title.data("url"),
         InputVal = _title.val();
         
         _this.show();
         if ( InputVal.length > 0 ) {
            currentUrl = currentUrl.replace('js_q_title',InputVal);
         } else {
           currentUrl = currentUrl.replace('+nt+filternt_title%3djs_q_title','').replace('filternt_title%3djs_q_title','');
         }
         currentUrl = `?q=${currentUrl}`;
         pjax_LoadHref(currentUrl);
    });

    const tabInitActive = document.querySelector('.t4s-tabs.t4s-type-accordion .t4s-tab-wrapper.t4s-active');
    const tabContent = document.querySelector('.t4s-tabs.t4s-type-accordion .t4s-tab-wrapper.t4s-active .t4s-tab-content');
    tabInitActive.classList.remove('t4s-active');
    tabContent.style.display = 'none';
});